<template>
  <div class="page">
    <fieldset>
      <legend>Marked Items</legend>
      <textarea v-model="itemInput" placeholder="Item Details"></textarea>
      <button v-on:click="processItems">Add Items</button>

      <div class="pool-list-container">
        <table class="pool-list">
          <tr>
            <th>Thai</th>
            <th>Delete</th>
          </tr>
          <tr
            class="pool-list__row"
            v-for="item in markedItems"
            v-bind:key="item.id"
          >
            <td>{{ item.properties.thai.value }}</td>

            <td><button class="btn--small" v-on:click="deleteItem(item)">╳</button></td>
          </tr>
        </table>
      </div>
    </fieldset>

  </div>
</template>

<style lang="scss">
table {
  border-collapse: collapse;
}

.pool-list__row:nth-of-type(odd) td {
  background: rgb(240, 240, 240);
}

.pool-list__row--disabled td {
  background: pink !important;
}
</style>

<script>

import { mapGetters } from 'vuex';

import * as db from '@/libs/db.js';

export default {
  name: "MarkedItemManager",
  store: db.store,
  data: function() {
    return {
      itemInput: '',
    }
  },
  computed: {
    ...mapGetters(['markedItems']),
  },
  methods: {
    async processItems() {
      var inputWords = this.itemInput.split("\n");

      inputWords = inputWords.map((thaiWord) => {
        let item = db.createItem("-", thaiWord);
        item.placeholder = true;
        return item;
      });

      await this.$store.dispatch('addItems', inputWords);

      this.itemInput = "";
      console.log(`Marked ${inputWords.length} new words.`);
    },
    async deleteItem(item) {
      await this.$store.dispatch('deleteItem', item.id);
    },
  },
  mounted() {
    // this.$store.dispatch('init');
  },
}
</script>

<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
